/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMicroAuthDetails} from '../api'

 export const useQueryGetMicroAuthDetails = createReactQueryHook('getMicroAuthDetails', getMicroAuthDetails)
